export default (file) => {
  if (!file) return '';

  if (file instanceof File) {
    return file;
  }

  return file.fileName || file;
};
